import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`

const Input = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.surface};
  position: relative;
  transition: all 0.2s;
  margin: 0;

  &:checked {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  &:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
  }
`

const LabelText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`

export function Radio({ label, checked, onChange, name, value, ...props }) {
  return (
    <Wrapper>
      <Input 
        type="radio" 
        name={name}
        value={value}
        checked={checked} 
        onChange={onChange} 
        {...props} 
      />
      {label && <LabelText>{label}</LabelText>}
    </Wrapper>
  )
}
